import React, { useState } from 'react';
import { Button, CardContent, Grid, Hidden, TextField, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { useStyles } from './FabricaInsumosProducaoStyles';
import clsx from 'clsx';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DeleteIcon from '@material-ui/icons/Delete';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';

export const FabricaInsumosProducao = props => {
  const {
    insumos,
    insumosOrigem,
    setInsumosOrigem,
    insumosDestino,
    setInsumosDestino,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    fabricar
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const [insumoSelecionadoOrigem, setInsumoSelecionadoOrigem] = useState();
  const [modoEdicaoInsumoOrigem, setModoEdicaoInsumoOrigem] = useState(false);
  const [quantidadeSelecionadaOrigem, setQuantidadeSelecionadaOrigem] = useState();
  const [quantidadePerdaOrigem, setQuantidadePerdaOrigem] = useState();

  const [insumoSelecionadoDestino, setInsumoSelecionadoDestino] = useState();
  const [modoEdicaoInsumoDestino, setModoEdicaoInsumoDestino] = useState(false);
  const [quantidadeSelecionadaDestino, setQuantidadeSelecionadaDestino] = useState();
  const [refreshState, setRefreshState] = useState(new Date());


  // --------------------- METODOS PARA INSUMO ORIGEM --------------------------
  function salvarInsumoOrigem(event, index) {
    try{
      event.preventDefault();
      if(!insumoSelecionadoOrigem){
        setMessageSnack('Informe o insumo a ser usado na geração');
        setTypeSnack('warning');
        setShowMessageSnack(true);
        return
      }
      if(!quantidadeSelecionadaOrigem){
        setMessageSnack('Informe uma quantidade válida para ser usada na geração');
        setTypeSnack('warning');
        setShowMessageSnack(true);
        return;
      }
      let quantidade = quantidadeSelecionadaOrigem > 0 ? (quantidadeSelecionadaOrigem * -1) : quantidadeSelecionadaOrigem;
      let perda = quantidadePerdaOrigem > 0 ? (quantidadePerdaOrigem * -1) : quantidadePerdaOrigem;
      let novoInsumoOrigem = {
        idInsumo: insumoSelecionadoOrigem.idInsumo,
        insumo: insumoSelecionadoOrigem,
        quantidade: quantidade,
        perda: perda,
        modoEdicao: false,
      };
      insumosOrigem[index] = novoInsumoOrigem;
      setInsumosOrigem(insumosOrigem);
      setInsumoSelecionadoOrigem(null);
      setQuantidadeSelecionadaOrigem(null);
      setModoEdicaoInsumoOrigem(false);
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao salvar insumo. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  function adicionarNovoInsumoOrigemBranco(event) {
    try{
      event.preventDefault();
      let novoInsumoOrigem = {
        idInsumo: null,
        insumo: null,
        quantidade: null,
        modoEdicao: true,
      };
      setModoEdicaoInsumoOrigem(true);
      insumosOrigem.push(novoInsumoOrigem);
      setRefreshState(new Date());
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao adicionar novo insumo. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }

  }

  function removerInsumoOrigem(event, index) {
    try{
      event.preventDefault();
      insumosOrigem.splice(index, 1);
      setInsumosOrigem(insumosOrigem);
      setRefreshState(new Date());
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao remover insumo. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  function ativarModoEdicaoInsumoOrigem(event, index) {
    try{
      event.preventDefault();
      setInsumoSelecionadoOrigem(insumosOrigem[index].insumo);
      setQuantidadeSelecionadaOrigem((insumosOrigem[index].quantidade < 0 ? insumosOrigem[index].quantidade * -1 : insumosOrigem[index].quantidade));
      insumosOrigem[index].modoEdicao = true;
      setInsumosOrigem(insumosOrigem);
      setModoEdicaoInsumoOrigem(true);
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao colocar insumo em modo edição. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }


  // --------------------- METODOS PARA INSUMO DESTINO --------------------------
  function salvarInsumoDestino(event, index) {
    try{
      event.preventDefault();
      if(!insumoSelecionadoDestino){
        setMessageSnack('Informe o insumo a ser usado na geração');
        setTypeSnack('warning');
        setShowMessageSnack(true);
        return
      }
      if(!quantidadeSelecionadaDestino){
        setMessageSnack('Informe uma quantidade válida para ser usada na geração');
        setTypeSnack('warning');
        setShowMessageSnack(true);
        return;
      }
      let quantidade = quantidadeSelecionadaDestino < 0 ? (quantidadeSelecionadaDestino * -1) : quantidadeSelecionadaDestino;
      let novoInsumoDestino = {
        idInsumo: insumoSelecionadoDestino.idInsumo,
        insumo: insumoSelecionadoDestino,
        quantidade: quantidade,
        modoEdicao: false,
      };
      insumosDestino[index] = novoInsumoDestino;
      setInsumosDestino(insumosDestino);
      setInsumoSelecionadoDestino(null);
      setQuantidadeSelecionadaDestino(null);
      setModoEdicaoInsumoDestino(false);
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao salvar insumo. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  function adicionarNovoInsumoDestinoBranco(event) {
    try{
      event.preventDefault();
      let novoInsumoDestino = {
        idInsumo: null,
        insumo: null,
        quantidade: null,
        modoEdicao: true,
      };
      setModoEdicaoInsumoDestino(true);
      insumosDestino.push(novoInsumoDestino);
      setRefreshState(new Date());
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao adicionar novo insumo. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }

  }

  function removerInsumoDestino(event, index) {
    try{
      event.preventDefault();
      insumosDestino.splice(index, 1);
      setInsumosDestino(insumosDestino);
      setRefreshState(new Date());
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao remover insumo. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  function ativarModoEdicaoInsumoDestino(event, index) {
    try{
      event.preventDefault();
      setInsumoSelecionadoDestino(insumosDestino[index].insumo);
      setQuantidadeSelecionadaDestino(insumosDestino[index].quantidade);
      insumosDestino[index].modoEdicao = true;
      setInsumosDestino(insumosDestino);
      setModoEdicaoInsumoDestino(true);
    }
    catch (e) {
      setMessageSnack('Ocorreu um erro ao colocar insumo em modo edição. Contate o suporte');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <Card
          variant={'elevation'}
          elevation={8}
          className={clsx({
            [classes.root]: true
          })}
        >
          <CardContent>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      color="textPrimary"
                      gutterBottom
                      className={clsx({
                        [classes.title]: true
                      })}
                    >
                      Insumos que serão usados
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Button
                      variant="contained"
                      color={'primary'}
                      className={classes.buttonDelete}
                      onClick={e => adicionarNovoInsumoOrigemBranco(e)}
                      startIcon={<AddIcon />}
                    >
                      novo insumo
                    </Button>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <List dense>
                      {insumosOrigem.map((element, index) => {
                        return (
                          !element.modoEdicao ?
                          (
                            <Grid
                              container
                              spacing={2}
                            >
                            <Grid
                                item
                                md={12}
                                xs={12}
                              >
                                <ListItem>
                                  <ListItemAvatar>
                                    <Avatar>
                                      <DoubleArrowIcon />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={
                                      <Grid
                                        container
                                        spacing={0}
                                      >
                                        <Grid
                                          item
                                          md={12}
                                          xs={12}
                                        >
                                          <Typography
                                            variant="h6"
                                            color="textPrimary"
                                            gutterBottom
                                            className={clsx({
                                              [classes.textoPrimarioItens]: true
                                            })}
                                          >
                                            {`Insumo: ${element.insumo.descricao}`}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    }
                                    secondary={
                                      <Grid
                                        container
                                        spacing={0}
                                      >
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                        >
                                          <Grid
                                            container
                                          >
                                            <Grid
                                              item
                                              md={7}
                                              xs={12}
                                            >
                                              {`Quantidade: ${element.quantidade}`}
                                            </Grid>
                                            <Grid
                                              item
                                              md={7}
                                              xs={12}
                                            >
                                              {`Perda: ${element.perda}`}
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    }
                                  />
                                  <ListItemSecondaryAction>
                                    <Grid
                                      container
                                    >
                                      <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        className={clsx({
                                          [classes.gridBotoesAcoes]: true
                                        })}
                                      >
                                        {
                                          !modoEdicaoInsumoOrigem &&
                                          <IconButton
                                            edge="end"
                                            onClick={e => removerInsumoOrigem(e, index)}
                                          >
                                            <DeleteIcon fontSize={'small'}/>
                                          </IconButton>
                                        }

                                      </Grid>
                                      <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        className={clsx({
                                          [classes.gridBotoesAcoes]: true
                                        })}
                                      >
                                        {
                                          !modoEdicaoInsumoOrigem &&
                                          <IconButton
                                            edge="end"
                                            onClick={e => ativarModoEdicaoInsumoOrigem(e, index)}
                                          >
                                            <EditIcon fontSize={'small'}/>
                                          </IconButton>
                                        }
                                      </Grid>
                                    </Grid>
                                  </ListItemSecondaryAction>
                                </ListItem>
                                <Divider variant="inset" component="li" />
                              </Grid>

                            </Grid>
                          )
                          :
                          (
                            <Grid
                              container
                              spacing={2}
                            >
                              <Grid
                                item
                                md={12}
                                xs={12}
                              >
                                <ListItem>
                                  <ListItemAvatar>
                                    <Avatar>
                                      <DoubleArrowIcon />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={
                                      <Grid
                                        container
                                        spacing={2}
                                      >
                                        <Grid
                                          item
                                          md={12}
                                          xs={12}
                                        >
                                          <Autocomplete
                                            options={insumos}
                                            getOptionLabel={ (insumo) => `${insumo.descricao}`}
                                            id={'insumoSelecionadoOrigem'}
                                            value={insumoSelecionadoOrigem}
                                            openOnFocus
                                            onChange={(e, insumo) => {
                                              e.preventDefault();
                                              setInsumoSelecionadoOrigem(insumo);
                                            }}
                                            renderInput={(params) => <
                                              TextField
                                              {...params}
                                              label="Insumo"
                                              margin="dense"
                                              fullWidth
                                              variant='outlined'
                                            />}
                                          />
                                        </Grid>
                                        <Grid
                                          item
                                          md={5}
                                          xs={12}
                                        >
                                          <CurrencyTextField
                                            label="Quantidade"
                                            variant="outlined"
                                            value={quantidadeSelecionadaOrigem}
                                            currencySymbol="Quantidade"
                                            outputFormat="number"
                                            decimalCharacter=","
                                            digitGroupSeparator='.'
                                            fullWidth
                                            minimumValue={0}
                                            margin='dense'
                                            onChange={(event, value) => {
                                              setQuantidadeSelecionadaOrigem(value)
                                            }}
                                          />
                                        </Grid>

                                        <Grid
                                          item
                                          md={5}
                                          xs={12}
                                        >
                                          <CurrencyTextField
                                            label="Perda"
                                            variant="outlined"
                                            value={quantidadePerdaOrigem}
                                            currencySymbol="Perda"
                                            outputFormat="number"
                                            decimalCharacter=","
                                            digitGroupSeparator='.'
                                            fullWidth
                                            minimumValue={0}
                                            margin='dense'
                                            onChange={(event, value) => {
                                              setQuantidadePerdaOrigem(value)
                                            }}
                                          />
                                        </Grid>
                                      </Grid>

                                    }
                                    secondary={'Preencha as informações para incluir o insumo na fabricação'}
                                  />
                                  <ListItemSecondaryAction>
                                    <Grid
                                      container
                                    >
                                      <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        className={clsx({
                                          [classes.gridBotoesAcoes]: true,
                                        })}
                                      >
                                        {
                                          modoEdicaoInsumoOrigem &&
                                          <IconButton
                                            edge="end"
                                            onClick={e => removerInsumoOrigem(e, index)}
                                          >
                                            <DeleteIcon fontSize={'small'}/>
                                          </IconButton>
                                        }
                                      </Grid>
                                      <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        className={clsx({
                                          [classes.gridBotoesAcoes]: true
                                        })}
                                      >
                                        {
                                          modoEdicaoInsumoOrigem &&
                                          <IconButton
                                            edge="end"
                                            onClick={e => salvarInsumoOrigem(e, index)}
                                          >
                                            <CheckIcon />
                                          </IconButton>
                                        }
                                      </Grid>
                                    </Grid>
                                  </ListItemSecondaryAction>
                                </ListItem>
                              </Grid>
                              <Grid
                                item
                                md={12}
                                xs={12}
                              >
                                <Divider variant="inset" component="li" />
                              </Grid>
                            </Grid>
                          )
                        )
                      }


                      )}
                    </List>
                  </Grid>
                </Grid>

              </Grid>
              <Grid
                item
                md={1}
                xs={12}
              >
                <Divider className={classes.dividerGrids} orientation={isDesktop ? 'vertical' : 'horizontal'} />
              </Grid>
              <Grid
                item
                md={5}
                xs={12}
              >
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Typography
                      variant="h5"
                      color="textPrimary"
                      gutterBottom
                      className={clsx({
                        [classes.title]: true
                      })}
                    >
                      Insumos que serão produzidos
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <Button
                      variant="contained"
                      color={'primary'}
                      className={classes.buttonDelete}
                      onClick={e => adicionarNovoInsumoDestinoBranco(e)}
                      startIcon={<AddIcon />}
                    >
                      novo insumo
                    </Button>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <List dense>
                      {insumosDestino.map((element, index) => {
                        return (
                          !element.modoEdicao ?
                            (
                              <Grid
                                container
                                spacing={2}
                              >
                                <Grid
                                  item
                                  md={12}
                                  xs={12}
                                >
                                  <ListItem>
                                    <ListItemAvatar>
                                      <Avatar>
                                        <DoubleArrowIcon />
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <Grid
                                          container
                                          spacing={0}
                                        >
                                          <Grid
                                            item
                                            md={12}
                                            xs={12}
                                          >
                                            <Typography
                                              variant="h6"
                                              color="textPrimary"
                                              gutterBottom
                                              className={clsx({
                                                [classes.textoPrimarioItens]: true
                                              })}
                                            >
                                              {`Insumo: ${element.insumo.descricao}`}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      }
                                      secondary={
                                        <Grid
                                          container
                                          spacing={0}
                                        >
                                          <Grid
                                            item
                                            md={6}
                                            xs={12}
                                          >
                                            <Grid
                                              container
                                            >
                                              <Grid
                                                item
                                                md={7}
                                                xs={12}
                                              >
                                                {`Quantidade: ${element.quantidade}`}
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      }
                                    />
                                    <ListItemSecondaryAction>
                                      <Grid
                                        container
                                      >
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                          className={clsx({
                                            [classes.gridBotoesAcoes]: true
                                          })}
                                        >
                                          {
                                            !modoEdicaoInsumoDestino &&
                                            <IconButton
                                              edge="end"
                                              onClick={e => removerInsumoDestino(e, index)}
                                            >
                                              <DeleteIcon fontSize={'small'}/>
                                            </IconButton>
                                          }

                                        </Grid>
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                          className={clsx({
                                            [classes.gridBotoesAcoes]: true
                                          })}
                                        >
                                          {
                                            !modoEdicaoInsumoDestino &&
                                            <IconButton
                                              edge="end"
                                              onClick={e => ativarModoEdicaoInsumoDestino(e, index)}
                                            >
                                              <EditIcon fontSize={'small'}/>
                                            </IconButton>
                                          }
                                        </Grid>
                                      </Grid>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                  <Divider variant="inset" component="li" />
                                </Grid>

                              </Grid>
                            )
                            :
                            (
                              <Grid
                                container
                                spacing={2}
                              >
                                <Grid
                                  item
                                  md={12}
                                  xs={12}
                                >
                                  <ListItem>
                                    <ListItemAvatar>
                                      <Avatar>
                                        <DoubleArrowIcon />
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <Grid
                                          container
                                          spacing={1}
                                        >
                                          <Grid
                                            item
                                            md={6}
                                            xs={12}
                                          >
                                            <Autocomplete
                                              options={insumos}
                                              getOptionLabel={ (insumo) => `${insumo.descricao}`}
                                              id={'insumoSelecionadoDestino'}
                                              value={insumoSelecionadoDestino}
                                              openOnFocus
                                              onChange={(e, insumo) => {
                                                e.preventDefault();
                                                setInsumoSelecionadoDestino(insumo);
                                              }}
                                              renderInput={(params) => <
                                                TextField
                                                {...params}
                                                label="Insumo"
                                                margin="dense"
                                                fullWidth
                                                variant='outlined'
                                              />}
                                            />
                                          </Grid>
                                          <Grid
                                            item
                                            md={4}
                                            xs={12}
                                          >
                                            <CurrencyTextField
                                              label="Quantidade"
                                              variant="outlined"
                                              value={quantidadeSelecionadaDestino}
                                              currencySymbol="Qtd"
                                              outputFormat="number"
                                              decimalCharacter=","
                                              digitGroupSeparator='.'
                                              fullWidth
                                              minimumValue={0}
                                              margin='dense'
                                              onChange={(event, value) => {
                                                setQuantidadeSelecionadaDestino(value)
                                              }}
                                            />
                                          </Grid>
                                        </Grid>

                                      }
                                      secondary={'Preencha as informações para incluir o insumo na fabricação'}
                                    />
                                    <ListItemSecondaryAction>
                                      <Grid
                                        container
                                      >
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                          className={clsx({
                                            [classes.gridBotoesAcoes]: true
                                          })}
                                        >
                                          {
                                            modoEdicaoInsumoDestino &&
                                            <IconButton
                                              edge="end"
                                              onClick={e => removerInsumoDestino(e, index)}
                                            >
                                              <DeleteIcon fontSize={'small'}/>
                                            </IconButton>
                                          }
                                        </Grid>
                                        <Grid
                                          item
                                          md={6}
                                          xs={12}
                                          className={clsx({
                                            [classes.gridBotoesAcoes]: true
                                          })}
                                        >
                                          {
                                            modoEdicaoInsumoDestino &&
                                            <IconButton
                                              edge="end"
                                              onClick={e => salvarInsumoDestino(e, index)}
                                            >
                                              <CheckIcon />
                                            </IconButton>
                                          }
                                        </Grid>
                                      </Grid>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                </Grid>
                                <Grid
                                  item
                                  md={12}
                                  xs={12}
                                >
                                  <Divider variant="inset" component="li" />
                                </Grid>
                              </Grid>
                            )
                        )
                      })

                      }
                    </List>
                  </Grid>
                </Grid>

              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
};
